import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetRegisterReducer } from '../reducers';

export const selectAssetRegisterFeature = createFeatureSelector<AssetRegisterReducer.AssetRegisterState>(AssetRegisterReducer.featureName);

export const selectAssetRegister = createSelector(selectAssetRegisterFeature, (state: AssetRegisterReducer.AssetRegisterState) => state.item);
